import React from 'react';
//import Carousel from '../Carousel';


function About  () {

  
  return (
    <div classname = "Info">
      {/* <Carousel /> */}
      <h1> About </h1>
    </div>
  );
};

export default About;